/*
 * Scripts needed for share this sharing to work
 * 
 */

 var switchTo5x=true;
 